module.exports = __webpack_public_path__ + "img/zf.9449c65c.png";